function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "20",
  viewBox: "0 0 40 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M30.013 19.472c0-5.755-4.665-10.42-10.42-10.42S9.176 13.72 9.176 19.472h20.837z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.279 19.473H0c0-.69.036-1.386.107-2.07l2.266.238c-.062.605-.094 1.22-.094 1.832z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.217 13.841L1.062 13.1a19.639 19.639 0 011.895-3.978l1.934 1.205a17.142 17.142 0 00-1.674 3.515zm32.748-.022a17.28 17.28 0 00-1.676-3.51l1.933-1.207a19.369 19.369 0 011.898 3.974l-2.155.743zM7.306 7.275L5.688 5.671a19.737 19.737 0 013.435-2.76l1.22 1.923a17.523 17.523 0 00-3.037 2.442zM31.87 7.26a17.483 17.483 0 00-3.037-2.435l1.214-1.927c1.24.785 2.4 1.712 3.438 2.754L31.87 7.26zM13.843 3.135L13.084.986a19.424 19.424 0 014.294-.983l.254 2.266c-1.29.143-2.565.436-3.79.866zm11.484-.007c-1.224-.43-2.5-.72-3.795-.862L21.782 0c1.465.163 2.91.492 4.297.977l-.752 2.151z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.19 19.473h-2.279c0-.612-.032-1.227-.094-1.832l2.266-.238c.068.684.107 1.38.107 2.07z",
  fill: "#000"
})));